import React from "react"

export const UncheckedState: React.FC = () => {
  // a11y: decorative — the checkbox input conveys state; hide the icon from SR
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="1" y="1" width="16" height="16" rx="1" stroke="#B0BEC5" />
    </svg>
  )
}
